import moment, { Moment } from 'moment-timezone'

import { DATE_FORMAT } from 'main/util/date'
import { TIME_FORMAT } from 'main/util/time'

export function momentHasElapsed(m: Moment) {
  return m.isBefore(moment())
}

export function momentFromDateAndTime(date: string, time: string, timezone: string) {
  return moment.tz(`${date} ${time}`, `${DATE_FORMAT} ${TIME_FORMAT}`, timezone)
}

export function momentFromDateTime(datetime: string, timezone: string) {
  return moment.tz(datetime, timezone)
}
